export default {
    name: 'TriangleUp',
    dimensions: { width: 10, height: 7 },
    content: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.00001 7C9.38441 7 9.73479 6.77965 9.90131 6.43319C10.0678 6.08672 10.021 5.67548 9.78088 5.3753L5.78088 0.375305C5.59111 0.138089 5.30379 0 5.00001 0C4.69623 0 4.40891 0.138089 4.21914 0.375305L0.21914 5.3753C-0.0209952 5.67547 -0.0678139 6.08672 0.0987062 6.43319C0.265226 6.77965 0.615604 7 1.00001 7L9.00001 7Z" fill="currentColor"/>
`
};
